/**
 * JWT Token Refresh Configuration
 * Centralized configuration for token management and activity monitoring
 */

export const JWT_CONFIG = {
  /**
   * Access Token Expiry
   * Should match backend JWT_ACCESS_EXPIRES_IN setting
   * Default: 15 minutes
   */
  ACCESS_TOKEN_EXPIRY: 15 * 60 * 1000, // 15 minutes in milliseconds

  /**
   * Refresh Token Expiry
   * Should match backend JWT_REFRESH_EXPIRES_IN setting
   * Default: 7 days
   */
  REFRESH_TOKEN_EXPIRY: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds

  /**
   * Proactive Refresh Threshold
   * When to proactively refresh the access token
   * Default: 5 minutes before expiry
   *
   * Example: If access token expires in 15 min, it will be refreshed when < 5 min remaining
   */
  REFRESH_THRESHOLD: 5 * 60 * 1000, // 5 minutes in milliseconds

  /**
   * Idle Timeout
   * How long before user is considered idle (no activity)
   * When idle, proactive token refresh will be paused
   * Default: 30 minutes
   */
  IDLE_TIMEOUT: 30 * 60 * 1000, // 30 minutes in milliseconds

  /**
   * Activity Events
   * DOM events to monitor for user activity
   */
  ACTIVITY_EVENTS: [
    'mousedown',
    'keydown',
    'scroll',
    'touchstart',
    'click',
    'mousemove'
  ],

  /**
   * Idle Check Interval
   * How often to check if user is idle
   * Default: 1 minute
   */
  IDLE_CHECK_INTERVAL: 60 * 1000, // 1 minute in milliseconds

  /**
   * Debug Mode
   * Enable console logging for token refresh activities
   */
  DEBUG_MODE: true, // Set to false in production
};

/**
 * Helper function to format milliseconds to human readable time
 */
export const formatTime = (ms) => {
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  if (hours > 0) {
    return `${hours}h ${minutes % 60}m`;
  } else if (minutes > 0) {
    return `${minutes}m`;
  } else {
    return `${seconds}s`;
  }
};

export default JWT_CONFIG;
